<template>
  <div class="sidebar-page-wrapper">
    <div
      class="sidebar-menu-bg"
      v-if="menuBg && $root.screenWidth > 550"
      :style="{ 'background-image': `url(${menuBg})` }"
    ></div>
    <div
      class="sidebar"
      :style="{
        'background-image': $root.screenWidth <= 550 ? `url(${menuBg})` : ''
      }"
    >
      <el-menu
        router
        :default-active="$route.path"
        class="sidebar-menu manage-sidebar-menu"
        :mode="$root.screenWidth > 550 ? 'vertical' : 'horizontal'"
      >
        <el-submenu
          index="/manage/organisation-profile"
          v-if="
            p('Organisations.View') ||
              p('Manufacturers.View') ||
              p('Organisations.Network.View') ||
              p('Organisations.RolesPermission.View') ||
              p('Observations.View') ||
              p('Organisations.Interoperability.View') ||
              p('Reports.View') ||
              p('Organisations.Customisation.View')
          "
        >
          <template slot="title">
            <span>{{ $t('text.organisation').toUpperCase() }}</span>
          </template>
          <el-menu-item
            index="/manage/organisation-profile"
            v-if="p('Organisations.View')"
            >{{ $t('text.profile') }}</el-menu-item
          >
          <el-menu-item
            index="/manage/buildings-rooms"
            v-if="p('Organisations.View')"
            >{{ $t('text.Buildings & Rooms') }}</el-menu-item
          >
          <!-- <el-menu-item index="/manage/organisation-structure"
            >Organisation Structure</el-menu-item
          > -->
          <el-menu-item
            index="/manage/manufacturers"
            v-if="p('Manufacturers.View')"
            >{{ $t('text.Manufacturers') }}</el-menu-item
          >
          <el-menu-item
            index="/manage/network-map"
            v-if="p('Organisations.Network.View')"
          >
            <span slot="title">{{ $t('text.network_map') }}</span>
          </el-menu-item>
          <!-- <el-menu-item index="/manage/network-utilisation">
            <span slot="title">{{
              $t('text.network_utilisation')
            }}</span>
          </el-menu-item> -->
          <el-menu-item
            index="/manage/admin-permissions"
            v-if="p('Organisations.RolesPermission.View')"
            >{{ $t('text.Roles & Permissions') }}</el-menu-item
          >
          <el-menu-item
            index="/manage/organisation-observation"
            v-if="p('Observations.View')"
            >{{ $t('text.observation') }}</el-menu-item
          >
          <el-menu-item
            index="/manage/application-link-key"
            v-if="p('Organisations.Interoperability.View')"
            >{{ $t('text.application_link_key') }}</el-menu-item
          >
          <el-menu-item
            index="/manage/organisation-setting"
            v-if="p('Organisations.Edit')"
            >{{ $t('text.settings') }}</el-menu-item
          >
          <!-- <el-menu-item
            index="/manage/organisation-reporting"
            v-if="p('Reports.View')"
            >{{ $t('text.reporting') }}</el-menu-item
          > -->
          <el-menu-item
            index="/manage/admin-customization"
            v-if="p('Organisations.Customisation.View')"
            >{{ $t('text.customization') }}</el-menu-item
          >
        </el-submenu>
        <el-menu-item index="/manage/my-account">
          <span slot="title">{{ $t('text.account').toUpperCase() }}</span>
        </el-menu-item>
        <el-submenu
          index="/manage/user-accounts"
          v-if="p('Users.View') || p('Users.Invite')"
        >
          <template slot="title">
            <span>{{ $t('text.users').toUpperCase() }}</span>
          </template>
          <el-menu-item index="/manage/user-accounts" v-if="p('Users.View')">{{
            $t('text.user_accounts')
          }}</el-menu-item>
          <el-menu-item index="/manage/invite-user" v-if="p('Users.Invite')">{{
            $t('text.invite_user')
          }}</el-menu-item>
        </el-submenu>
        <el-submenu index="/manage/patient-list" v-if="p('Patients.View')">
          <template slot="title">
            <span>{{
              $t('text.patients', {
                patients: $store.state.locale.patients
              }).toUpperCase()
            }}</span>
          </template>
          <el-menu-item index="/manage/patient-list" v-if="p('Patients.View')">{{
            $t('text.patients', {
              patients: $firstLetterCapitalize($store.state.locale.patients)
            })
          }}</el-menu-item>
          <el-menu-item index="/manage/data-privacy" v-if="p('Patients.View')">
            <span slot="title">{{ $t('text.Data Privacy') }}</span>
          </el-menu-item>
        </el-submenu>
        <el-submenu index="/manage/devices-pods" v-if="p('Devices.View')">
          <template slot="title">
            <span>{{ $t('text.Devices').toUpperCase() }}</span>
          </template>
          <el-menu-item
            index="/manage/devices-pods"
            v-if="p('Devices.Pod.View')"
            >{{ $t('text.pods') }}</el-menu-item
          >
          <el-menu-item
            index="/manage/devices-nodes"
            v-if="p('Devices.Node.View')"
          >
            <span slot="title">{{ $t('text.nodes') }}</span>
          </el-menu-item>
        </el-submenu>
        <!-- <el-submenu index="/manage/report" v-if="p('Reports.View')">
          <template slot="title">
            <span>{{ $t('text.report').toUpperCase() }}</span>
          </template>
          <el-menu-item index="/manage/report" v-if="p('Reports.Export')">{{
            $t('text.export')
          }}</el-menu-item>
          <el-menu-item
            index="/manage/report-history"
            v-if="p('Reports.View')"
            >{{ $t('text.history') }}</el-menu-item
          >
        </el-submenu> -->
        <!-- <el-submenu
          index="/manage/admin-algorithms"
          v-if="p('Organisations.Customisation.View')"
        >
          <template slot="title">
            <span>{{ $t('text.super_admin').toUpperCase() }}</span>
          </template>
          <el-menu-item
            index="/manage/admin-algorithms"
            v-if="p('Organisations.Customisation.View')"
            >{{ $t('text.algorithms') }}</el-menu-item
          >
          <el-menu-item
            index="/manage/admin-data-privacy"
            v-if="p('Organisations.Customisation.View')"
            >{{ $t('text.data_privacy') }}</el-menu-item
          >
        </el-submenu> -->
      </el-menu>
    </div>
    <div class="sidebar-type-page-content">
      <PatientFilter
        :showPatientBox="false"
        v-if="
          ['/manage/network-map', '/manage/organisation-observation'].includes(
            $route.path
          )
        "
      />
      <Helper v-if="$route.path !== '/manage/landing'" />
      <router-view ref="content" />
    </div>
  </div>
</template>

<script>
import Helper from '@/components/Helper.vue'
import PatientFilter from '@/components/dashboard/PatientFilter.vue'
export default {
  components: {
    Helper,
    PatientFilter
  },
  computed: {
    menuBg() {
      return this.$store.state.customization.menuBg
    }
  }
}
</script>
